import axios from "axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useBills = () =>
  useQuery({ queryKey: ["bills"], queryFn: async () => (await axios.get(`${API}/bills`)).data });

export const useIncomes = () =>
  useQuery({ queryKey: ["incomes"], queryFn: async () => (await axios.get(`${API}/incomes`)).data });

export const usePayments = () =>
  useQuery({ queryKey: ["payments"], queryFn: async () => (await axios.get(`${API}/payments`)).data });

export const useCreateBill = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => axios.post(`${API}/bills`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["bills"] }),
  });
};
export const useUpdateBill = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => axios.patch(`${API}/bills/${id}`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["bills"] }),
  });
};
export const useDeleteBill = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => axios.delete(`${API}/bills/${id}`),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["bills"] }); qc.invalidateQueries({ queryKey: ["payments"] }); },
  });
};

export const useCreateIncome = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => axios.post(`${API}/incomes`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["incomes"] }),
  });
};
export const useUpdateIncome = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => axios.patch(`${API}/incomes/${id}`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["incomes"] }),
  });
};
export const useDeleteIncome = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => axios.delete(`${API}/incomes/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["incomes"] }),
  });
};

export const useTogglePayment = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => axios.post(`${API}/payments/toggle`, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["payments"] }),
  });
};
